// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@synd/Overrides/Widgets/Basic/SocialLinks";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

linkListStyles.titleText = {
    variant: "h6",
    forwardAs: "h4",
    css: css`
        text-transform: uppercase;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        flex-wrap: nowrap;
        align-items: center;
    `,
};

linkListStyles.link = {
    mergeCss: true,
    typographyProps: {
        color: "common.ui11",
        size: fontConfig.xSmallSingleLine.size,
        weight: fontConfig.weight.medium,
        css: css`
            line-height: ${fontConfig.xSmallSingleLine.lineHeight};
            &:empty {
                display: none;
            }
        `,
    },
    css: css`
        gap: 6px;
    `,
};

linkListStyles.linkLabel = {
    ...fontConfig.xSmallSingleLine,
};

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        padding: 8px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
    `,
};
